// InvoicePageBreak Component

import InvoiceViewItemBase from './invoice_view_itembase.jsx'

class InvoicePageBreak extends InvoiceViewItemBase {
  render () {
    return super.render()
  }
}

export default InvoicePageBreak
